import { DeleteAsync, GetAsync } from "src/common/httpRequests";
import { MANUAL_DOCUMENT_SERVICE_URL } from "src/constants/api";
import { API_GATEWAY } from "src/constants/settings";

export interface IGetDraftsParams {
  documentClass: number;
  manualDocumentStatus: number;
  page: number;
  record: number;
}

const getManualDocumentDrafts = (params: IGetDraftsParams) => {
  return GetAsync(
    `${API_GATEWAY}${MANUAL_DOCUMENT_SERVICE_URL}/drafts`,
    undefined,
    undefined,
    { params },
  );
};

const getManualDocumentJson = (documentId: string) =>
  GetAsync(
    `${API_GATEWAY}${MANUAL_DOCUMENT_SERVICE_URL}/GetManualDocumentJson?documentId=${documentId}`,
  );

const deleteManualDocumentDraft = (documentId: string) =>
  DeleteAsync(
    `${API_GATEWAY}${MANUAL_DOCUMENT_SERVICE_URL}/DeleteManualDocument/${documentId}`,
  );

export {
  deleteManualDocumentDraft,
  getManualDocumentDrafts,
  getManualDocumentJson,
};
